/* eslint-disable no-param-reassign */
import { createSlice, current } from '@reduxjs/toolkit';
const AuthInitialState = {
    user: {
        success: null,
        name: null,
        email: null,
        phone: null,
        managerId: null,
        cpf: null,
        currentGroupId: null,
        currentDivisionId: null,
        totalErrors: null,
        msnErrors: null,
        groups: null,
        geid: null,
        abbreviation: null,
        token: null,
        firstAccess: null,
        provisionalPassword: null,
        permissions: null,
        mainScreen: null,
        currentGroup: null,
        dashboardConfig: null,
        color: null,
        title: null,
        logo: null,
        refreshToken: null,
        step: null,
        costCenters: null,
    },
    justLoggedIn: false,
};
const AuthSlicer = createSlice({
    name: 'auth',
    initialState: AuthInitialState,
    reducers: {
        setUser: (state, { payload: { user } }) => {
            state.user = user;
        },
        setDivisions: (state, { payload: { bases, group }, }) => {
            state.user.currentDivisionId = bases;
            state.user.currentGroupId = group;
        },
        setColor: (state, { payload: { color } }) => {
            state.user.color = color;
        },
        setEnterprise: (state, { payload: { title } }) => {
            state.user.title = title;
        },
        setLogo: (state, { payload: { logo } }) => {
            state.user.logo = logo;
        },
        setStep: (state, { payload: { step } }) => {
            state.user.step = step;
        },
        getManagerId: state => {
            current(state.user.managerId);
        },
        getToken: state => {
            current(state.user.token);
        },
        setJustLoggedIn: (state, { payload: justLoggendIn }) => {
            state.justLoggedIn = justLoggendIn;
        },
        setCostCenters: (state, { payload: costCenters }) => {
            state.user.costCenters = costCenters;
        },
        clearUser: () => AuthInitialState,
    },
});
export const { setUser, setColor, setEnterprise, clearUser, getToken, setDivisions, setStep, setLogo, getManagerId, setJustLoggedIn, setCostCenters, } = AuthSlicer.actions;
export default AuthSlicer.reducer;
